import { render, staticRenderFns } from "./ReportesHorariosIngreso.vue?vue&type=template&id=53e4f71a&scoped=true&"
import script from "./ReportesHorariosIngreso.vue?vue&type=script&lang=js&"
export * from "./ReportesHorariosIngreso.vue?vue&type=script&lang=js&"
import style0 from "./ReportesHorariosIngreso.vue?vue&type=style&index=0&id=53e4f71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4f71a",
  null
  
)

export default component.exports